import { render } from "./CheckPermissionEditorCmp.vue?vue&type=template&id=8beb0c36"
import script from "./CheckPermissionEditorCmp.vue?vue&type=script&lang=js"
export * from "./CheckPermissionEditorCmp.vue?vue&type=script&lang=js"

import "./CheckPermissionEditorCmp.vue?vue&type=style&index=0&id=8beb0c36&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__